import {
    Flex, useColorModeValue as colorValue
} from '@chakra-ui/react'
import Queue from './Queue'

const QueueDefault = () => {
    return (
        <Flex minH="100vh" bgColor={colorValue("gray.100", "gray.700")} justify="center" pt={14}>
            <Queue homeLink={true} />
        </Flex>
    )
}

export default QueueDefault
